import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AccessDenied } from './AccessDenied';

// The gate: loading → (unauthenticated → login | forbidden → access-denied) → authenticated. 'forbidden'
// only occurs in proxy (forward-auth) mode: the proxy authenticated the user upstream but they aren't
// provisioned in this app → show access-denied, NOT a login prompt.
export function ProtectedRoute() {
  const { state } = useAuth();

  switch (state.status) {
    case 'loading':
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-brand-rose border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-slate-500 font-medium">Loading...</p>
          </div>
        </div>
      );

    case 'unauthenticated':
      return <Navigate to="/login" replace />;

    case 'forbidden':
      return <AccessDenied />;

    case 'authenticated':
      return <Outlet />;
  }
}
